import {
  Button,
  ButtonProps,
  FluentProvider,
  makeStyles,
  mergeClasses,
  PartialTheme,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";
import { isVisibleComponetBaseOnRole } from "@/commons/RoleFunction.ts";


interface ButtonCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  isIconButton?: boolean;
}

const useStyles = makeStyles({
  root: {
    minWidth: "80px"
  },
  root2: {
    minWidth: "10px"
  },
});

const ButtonCustom = (props: ButtonCustomProps & ButtonProps) => {
  const styles = useStyles();
  const isCanBeVisible = isVisibleComponetBaseOnRole(
    props.rcRole,
    props.requireRoles
  );
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return isCanBeVisible ? (
    <FluentProvider
      theme={
        props.theme === "dark"
          ? webDarkTheme
          : {
            ...renderTheme,
            colorBrandBackground: "rgb(70, 101, 136)",
            colorBrandBackgroundHover: "rgb(21, 51, 89)",
            colorNeutralForeground2BrandHover: "rgb(21, 51, 89)",
          }
      }
    >
      <Button {...props} className={mergeClasses(props.isIconButton ? styles.root2 : styles.root, props.className)}/>
    </FluentProvider>
  ) : null;
};

export default ButtonCustom;
